<template>
  <svg
    v-if="layout === 'sm'"
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.41 4.59008L0 6.00008L4 10.0001L12 2.00008L10.59 0.580078L4 7.17008L1.41 4.59008Z"
      :fill="fill"
    />
  </svg>

  <svg
    v-else-if="layout === 'sm-2'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99992 14.6667C4.3197 14.6627 1.33729 11.6803 1.33325 8.00005V7.86672C1.40654 4.20307 4.42298 1.28536 8.08703 1.33397C11.7511 1.38259 14.6891 4.37931 14.6651 8.04361C14.6412 11.7079 11.6643 14.666 7.99992 14.6667ZM4.93992 7.72672L3.99992 8.66672L6.66659 11.3334L11.9999 6.00005L11.0599 5.05339L6.66659 9.44672L4.93992 7.72672Z"
      :fill="semanticColorLookup('surface.on-surface')"
    />
  </svg>

  <svg
    v-else-if="layout === 'md'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.52501 17.657L4.57501 12.707L5.98901 11.293L9.52651 14.8265L9.52501 14.828L18.01 6.34302L19.424 7.75702L10.939 16.243L9.52601 17.656L9.52501 17.657Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsCheck'
})

defineProps({
  layout: {
    type: String,
    default: 'sm',
    validator: value => ['sm', 'sm-2', 'md'].includes(value)
  },

  fill: {
    type: String,
    default: '#ffffff'
  }
})
</script>
